import React from 'react'
import { Helmet } from 'react-helmet'

export const PreviewPrismic = () => (
  <Helmet>
    <script async defer src={`https://static.cdn.prismic.io/prismic.js?new=true&repo=${process.env.REACT_APP_PRISMIC_REPO}`} />
  </Helmet>
)
